import { Suspense } from "react"
import { ArrowLeft } from "react-feather"
import { useNavigate, useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { ReactErrorBoundary } from "@/components/ui/error-boundary"
import { SectionLoading } from "@/components/ui/loading"
import { TenantDetailContent } from "./components/TenantDetailContent"

export const TenantDetailPage = () => {
  const navigate = useNavigate()
  const { tenantId } = useParams<{ tenantId: string }>()

  if (!tenantId) {
    // render 404 page
    return <div>賃借人IDが指定されていません。</div>
  }

  return (
    <div className="space-y-6">
      {/* Header - 戻るボタン */}
      <div className="flex items-center gap-2.5">
        <Button
          variant="ghost"
          size="icon"
          className="w-7 h-7 shadow-sm"
          onClick={() => navigate("/tenants")}
        >
          <ArrowLeft size={14} />
        </Button>
        <h2 className="text-sm font-semibold text-slate-600">賃借人一覧に戻る</h2>
      </div>

      <h1 className="text-2xl font-bold">賃借人詳細</h1>

      {/* Main Content */}
      <ReactErrorBoundary>
        <Suspense fallback={<SectionLoading />}>
          <TenantDetailContent tenantId={tenantId} />
        </Suspense>
      </ReactErrorBoundary>
    </div>
  )
}
